import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'

export const useApplicantTempoStatus = (applicantId?: number) =>
  useQuery({
    queryKey: ['tempo', 'applicant-sync-status', applicantId],
    queryFn: () =>
      fetchApiWithToken<{ synced: boolean; canSync: boolean }>({
        method: 'get',
        url: `/v1/tempo/applicants/${applicantId}/sync-status`
      }),
    enabled: !!applicantId,
    staleTime: 60_000
  })
